<template>
  <div>
    <ul class="mt-4">
      <li v-for="(item, index) in items" :key="index">
        <div
          class="d-flex align-items-center"
          @click="showSubitems(item, 'item', 'fileType')"
        >
          <div>
            <i class="item-icon fas fa-folder me-2"></i>
          </div>
          <div>
            <p class="item-name mb-0 capitalize">{{ item.value }}</p>
          </div>
        </div>

        <ul class="subitems-list" v-if="item.showSubitems">
          <li v-for="(subitem, index) in item.subitems" :key="index">
            <div
              class="d-flex align-items-center"
              @click="showSubitems(subitem, 'subitem', 'year')"
            >
              <div>
                <i class="item-icon fas fa-folder me-2"></i>
              </div>
              <div>
                <p class="item-name mb-0">{{ subitem.value }}</p>
              </div>
            </div>

            <ul class="subitems-list" v-if="subitem.showSubitems">
              <li
                v-for="(categoryItem, index) in subitem.subitems"
                :key="index"
              >
                <div
                  class="d-flex align-items-center"
                  @click="emitFilter('category', categoryItem.uuid)"
                >
                  <div>
                    <i class="item-icon fas fa-folder me-2"></i>
                  </div>
                  <div>
                    <p class="item-name mb-0">{{ categoryItem.value }}</p>
                  </div>
                </div>
              </li>
            </ul>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: ["items"],
  data() {
    return {
      fileType: null,
      year: null,
      category: null,
    };
  },
  methods: {
    showSubitems(item, type, data) {
      if (type === "item") {
        this.items.forEach((it) => {
          if (it !== item) {
            it.showSubitems = false;
          }
        });
      }

      item.showSubitems = !item.showSubitems;

      if (item.showSubitems) {
        this.emitFilter(data, item.uuid);
      }
    },

    emitFilter(data, value) {
      switch (data) {
        case "fileType": {
          this.fileType = value;
          break;
        }
        case "year": {
          this.year = value;
          break;
        }
        case "category": {
          this.category = value;
          break;
        }
      }

      this.$emit("filter", {
        fileType: this.fileType,
        year: this.year,
        category: this.category,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
ul {
  padding-left: 0;
  list-style: none;

  li {
    margin-bottom: 10px;
    font-size: 18px;
    cursor: pointer;
  }

  .subitems-list {
    margin-top: 10px;
    padding-left: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/dashboard/components/Tree.vue